import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import api from '../../services/api';
import { formatDateTime } from '../../utils/Utils';
import DataTable from '../../components/ui/DataTable';
import Button from '../../components/ui/Button';

const Container = styled.div``;

// Task 7'deki hata kararı bu ekran olmadan eksik kalır: hata kaybolmuyor ama
// kimse görmüyorsa `catch { }` ile arasında fark kalmaz.
export default function AssignmentFailuresPage() {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [busy, setBusy] = useState(null);

  const yukle = useCallback(async () => {
    setFetching(true);
    const res = await api.get('/v1/assignment-failures');
    // api.js GET okumalarında REDDETMEZ — gerçek sinyal res.data.status.
    if (res?.data?.status === true) setRows(res.data.data || []);
    setFetching(false);
  }, []);

  useEffect(() => { yukle(); }, [yukle]);

  const yenidenDene = useCallback(async (id) => {
    setBusy(id);
    try {
      await api.post(`/v1/assignment-failures/${id}/retry`);
      await yukle();
    } finally {
      setBusy(null);
    }
  }, [yukle]);

  const columns = useMemo(() => [
    { name: 'operation', label: t('assignmentFailures.operation'), options: { filter: false, sort: false } },
    {
      name: 'dlqAt',
      label: t('assignmentFailures.failedAt'),
      options: {
        filter: false, sort: false,
        customBodyRender: (v) => (v ? formatDateTime(v) : '-'),
      },
    },
    { name: 'retryCount', label: t('assignmentFailures.attempts'), options: { filter: false, sort: false } },
    {
      name: 'lastError',
      label: t('assignmentFailures.error'),
      options: { filter: false, sort: false, customBodyRender: (v) => v || '-' },
    },
    {
      name: 'id',
      label: ' ',
      options: {
        filter: false, sort: false,
        customBodyRender: (id) => (
          <Button onClick={() => yenidenDene(id)} disabled={busy === id}>
            {t('assignmentFailures.retry')}
          </Button>
        ),
      },
    },
  ], [t, busy, yenidenDene]);

  return (
    <Container>
      <DataTable
        title={t('assignmentFailures.title')}
        fetching={fetching}
        columns={columns}
        data={rows}
        totalRowCount={rows.length}
        pageIndex={0}
        pageSize={rows.length || 10}
      />
    </Container>
  );
}
